module.exports = "https://www.niulinkcloud.cn/_next/static/media/vip-lite.32fd62905258e82d28169af8a9b01cc2.jpg";